import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchChatRooms = createAsyncThunk('chat/fetchRooms', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/chat/rooms');
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to fetch chats');
  }
});

export const fetchMessages = createAsyncThunk('chat/fetchMessages', async ({ roomId, page }, { rejectWithValue }) => {
  try {
    const { data } = await api.get(`/chat/rooms/${roomId}/messages`, { params: { page } });
    return { roomId, messages: data.data };
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to fetch messages');
  }
});

export const sendMessage = createAsyncThunk('chat/sendMessage', async ({ roomId, content, type }, { rejectWithValue }) => {
  try {
    const { data } = await api.post(`/chat/rooms/${roomId}/messages`, { content, type });
    return { roomId, message: data.data };
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to send message');
  }
});

export const createChatRoom = createAsyncThunk('chat/createRoom', async (roomData, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/chat/rooms', roomData);
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to create chat');
  }
});

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    rooms: [], activeRoom: null, messages: {}, loading: false, error: null,
  },
  reducers: {
    setActiveRoom: (state, action) => { state.activeRoom = action.payload; },
    addMessage: (state, action) => {
      const { roomId, message } = action.payload;
      if (!state.messages[roomId]) state.messages[roomId] = [];
      state.messages[roomId].push(message);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatRooms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload || [];
      })
      .addCase(fetchChatRooms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages[action.payload.roomId] = action.payload.messages;
      })
      .addCase(fetchMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendMessage.pending, (state) => {
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        const { roomId, message } = action.payload;
        if (!state.messages[roomId]) state.messages[roomId] = [];
        state.messages[roomId].push(message);
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(createChatRoom.fulfilled, (state, action) => {
        state.rooms.unshift(action.payload); state.activeRoom = action.payload;
      });
  },
});

export const { setActiveRoom, addMessage } = chatSlice.actions;
export default chatSlice.reducer;
